import React from 'react'

const CategoryTag = ({children}) => {

    let seasonClass;

    if (children === "Season 2") {
        seasonClass = "s-2"
    } else if (children === "Season 1") {
        seasonClass = "s-1"
    };
    
    return (
        <div className={`category-tag ${seasonClass}`}>
            {children}
            <style jsx>{`
                div {
                    display: inline-block;
                    padding: 14px 24px;
                    border-radius: 40px;
                    background: rgba(230,230,230,.85);
                    color: #454545;
                    white-space: nowrap;
                    text-align: center;
                }

                .s-2 {
                    color: white;
                    background: linear-gradient(to right, #e66465, #9198e5);
                }

                .s-1 {
                    color: white;
                    background: orange;
                }
            `}</style>
        </div>
    )
}

export default CategoryTag